module.exports = __webpack_public_path__ + "img/case-bg.ed5bb9d4.png";